module.exports = __webpack_public_path__ + "img/road2.17ffb1c4.jpg";